import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format currency in EUR
export function formatCurrency(value, decimals = 0) {
  if (value === null || value === undefined) return '€ 0';
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

// Format percentage
export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined) return '0%';
  return `${Number(value).toFixed(decimals)}%`;
}

// Format number
export function formatNumber(value, decimals = 0) {
  if (value === null || value === undefined) return '0';
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

// Format datetime
export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

// Get status badge class
export function getStatusBadgeClass(status) {
  const statusMap = {
    'attiva': 'badge-success',
    'pianificazione': 'badge-warning',
    'sospesa': 'badge-danger',
    'chiusa': 'badge-default',
    'attivo': 'badge-success',
    'non_attivo': 'badge-default',
  };
  return statusMap[status] || 'badge-default';
}

// Get status label in Italian
export function getStatusLabel(status) {
  const statusMap = {
    'attiva': 'Attiva',
    'pianificazione': 'Pianificazione',
    'sospesa': 'Sospesa',
    'chiusa': 'Chiusa',
    'attivo': 'Attivo',
    'non_attivo': 'Non Attivo',
    'cliente': 'Cliente',
    'interna_rd': 'R&D',
    'interna_presales': 'Presales',
    'interna_formazione': 'Formazione',
    'interna_admin': 'Admin',
    'dipendente': 'Dipendente',
    'freelance': 'Freelance',
    'consulente': 'Consulente',
  };
  return statusMap[status] || status;
}

// Get tipo commessa color
export function getTipoCommessaClass(tipo) {
  const tipoMap = {
    'cliente': 'badge-success',
    'interna_rd': 'badge-info',
    'interna_presales': 'badge-warning',
    'interna_formazione': 'badge-info',
    'interna_admin': 'badge-default',
  };
  return tipoMap[tipo] || 'badge-default';
}

// Calculate margin class based on value
export function getMarginClass(value, target = 0) {
  if (value >= target) return 'text-emerald-600 dark:text-emerald-400';
  if (value >= target * 0.8) return 'text-amber-600 dark:text-amber-400';
  return 'text-red-600 dark:text-red-400';
}

// Generate unique ID
export function generateId() {
  return Math.random().toString(36).substr(2, 9);
}

// Truncate text
export function truncate(text, length = 50) {
  if (!text) return '';
  if (text.length <= length) return text;
  return text.substring(0, length) + '...';
}
